(function () {
    'use strict';

    angular
        .module('gov.services')
        .service('pagerService', pagerService);

    pagerService.$inject = [];

    function pagerService() {

        var service = {
            newPager: pager
        };

        return service;
    }

    function pager(options) {
        var that = {};

        var _numberOfItems = 0,
            _numberOfItemsPerPage = options && options.numberOfItemsPerPage ? options.numberOfItemsPerPage : 10,
            _currentPageNum = 1,
            _numberOfPages = 0;

        that.getNumberOfItems = getNumberOfItems;
        that.getNumberOfItemsPerPage = getNumberOfItemsPerPage;
        that.getCurrentPageNum = getCurrentPageNum;
        that.getNumberOfPages = getNumberOfPages;
        that.gotoFirstPage = gotoFirstPage;
        that.gotoPreviousPage = gotoPreviousPage;
        that.gotoNextPage = gotoNextPage;
        that.gotoLastPage = gotoLastPage;
        that.gotoFirstPageAllowed = gotoFirstPageAllowed;
        that.gotoPreviousPageAllowed = gotoPreviousPageAllowed;
        that.gotoNextPageAllowed = gotoNextPageAllowed;
        that.gotoLastPageAllowed = gotoLastPageAllowed;
        that.updatePager = updatePager;
        that.updatePagerFromItems = updatePagerFromItems;
        that.getResultStartIndex = getResultStartIndex;
        that.getResultEndIndex = getResultEndIndex;

        return that;

        function updatePagerFromItems(items) {
            var numPages = !items || items.length === 0 ? 0 : Math.ceil(items.length / getNumberOfItemsPerPage());
            updatePager(!items ? 0 : items.length, 1, numPages);
        }

        function updatePager(numberOfItems, currentPageNum, numberOfPages) {
            _numberOfItems = numberOfItems;
            _currentPageNum = currentPageNum;
            _numberOfPages = numberOfPages;
        }

        function getNumberOfItems() {
            return _numberOfItems;
        }

        function getNumberOfItemsPerPage() {
            return _numberOfItemsPerPage;
        }

        function getCurrentPageNum() {
            return _currentPageNum;
        }

        function getNumberOfPages() {
            return _numberOfPages;
        }

        function gotoFirstPage() {
            _currentPageNum = 1;
        }

        function gotoPreviousPage() {
            if (!gotoPreviousPageAllowed()) return;

            _currentPageNum--;
        }

        function gotoNextPage() {
            if (!gotoNextPageAllowed()) return;

            _currentPageNum++;
        }

        function gotoLastPage() {
            if (!gotoLastPageAllowed()) return;

            _currentPageNum = _numberOfPages;
        }

        function gotoFirstPageAllowed() {
            return _currentPageNum > 1;
        }

        function gotoPreviousPageAllowed() {
            return gotoFirstPageAllowed();
        }

        function gotoNextPageAllowed() {
            return gotoLastPageAllowed();
        }

        function gotoLastPageAllowed() {
            return _currentPageNum < _numberOfPages;
        }

        function getResultStartIndex() {
            return (_currentPageNum - 1) * _numberOfItemsPerPage + 1;
        }

        function getResultEndIndex() {
            var pageEnd = _currentPageNum * _numberOfItemsPerPage;

            if (pageEnd > _numberOfItems) {
                return _numberOfItems;
            }

            return pageEnd;
        }
    }
})();